import styled from "styled-components";
import Button from "~/componentes/Button";
import { Colors } from "~/config/Colors";

export const ThisButtonStyle = styled(Button)`
  transition: 0.1s ease;
  height: ${(props) =>
    props.tabheight > 2.4 ? `${props.tabheight}rem` : "2.4rem"};
  min-width: ${(props) =>
    props.tabwidth > 2.4 ? `${props.tabwidth}rem` : "6rem"};
  padding: 0.625rem 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  font-size: 0.8rem;
  position: relative;
  border: none;
  border-radius: 0.6rem;
  margin-left: 0.8rem;
  background: ${(props) =>
    props.ativo
      ? props.revertcolor
        ? Colors.Color2
        : props.corFundo
      : props.revertcolor
        ? props.corFundo
        : Colors.Color2};
  color: ${(props) =>
    props.ativo
      ? props.revertcolor
        ? Colors.ftColor2
        : props.corDestaque
      : props.revertcolor
        ? props.corDestaque
        : Colors.Color7};

  .TabsWrapper_Tab_DefaultTabIconStyle {
    ${(props) =>
    props.ismobile
      ? `
      margin: auto;
      font-size: 1.2rem;
    `
      : `
      margin-right: 0.5rem;
    `};
  }

  .item-color {
    width: 1.2rem;
    height: 1.2rem;
    background: ${(props) => props.corDestaque};
    margin-right: 0.6rem;
    border-radius: 0.2rem;
  }

  p {
    line-height: 1rem;
  }

  &:active {
    transform: scale(0.97);
  }

  :hover {
    background: ${(props) => props.corFundo};
    color: ${(props) => props.corDestaque};
  }
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  z-index: 0;
  padding: 0rem;
`;
